import React from "react";
import ReactTooltip from "react-tooltip";

const tagsInfo = {
  isLocked: { color: "#4CAF50", text: "Locked" }, // Green
  isInactive: { color: "#2196F3", text: "INACTIVE" }, // Blue
  isAdmin: { color: "#FFC107", text: "Admin" }, // Amber
  isDeleted: { color: "#F44336", text: "Deleted" }, // Red
  isCorporate: { color: "#9C27B0", text: "Corporate" }, // Purple
  isCorporateReporting: { color: "#00BCD4", text: "Reporting Portal" }, // Cyan
  isLinked: { color: "#FF9800", text: "Linked" }, // Orange
  isMultiOrganizations: { color: "#795548", text: "Multi Organizations" }, // Brown
  isQA: { color: "#607D8B", text: "QA" }, // Blue Grey
  isNotAssigned: { color: "#E91E63", text: "NOT ASSIGNED TO ANY ORGANIZATION" }, // Pink
  isEmailConfirmed: { color: "#009688", text: "Email is not confirmed" }, // Teal
  isLoginInFailed: { color: "#3F51B5", text: "User can't login (no permissions)" }, // Indigo
  isExpired: { color: "#9E9E9E", text: "Expired" } // Grey (Muted)
};

export const TagsList = () => {
  return (
    <div className="admin-users__tags">
      <p data-tip data-for="all-tags">
        Tags Info
        <span className="admin-users__tags icon">
          {[
            { color: tagsInfo.isNotAssigned.color, left: 0 },
            { color: tagsInfo.isLoginInFailed.color, left: 4 },
            { color: tagsInfo.isLocked.color, left: 8 }
          ].map((item) => (
            <span
              key={item.color}
              className="glyphicon glyphicon-tag"
              style={{
                color: item.color,
                position: "absolute",
                left: `${item.left}px`,
                top: 0
              }}
            />
          ))}
        </span>
      </p>
      <ReactTooltip id="all-tags" effect="solid" place="right">
        <div className="tags-list">
          {Object.entries(tagsInfo).map(([key, value]) => {
            return (
              <div key={key} className="tags-list__item">
                <span className="glyphicon glyphicon-tags" style={{ color: value.color }} />
                <span> - </span>
                <span> {value.text}</span>
              </div>
            );
          })}
        </div>
      </ReactTooltip>
    </div>
  );
};

export const Tags = ({ statuses }) => {
  let icon = "glyphicon glyphicon-tags";
  const tooltipId = "tags-tooltip";

  return (
    <>
      {Object.entries(statuses).map(([key, value]) => {
        if (value) {
          return (
            <span
              key={key}
              className={icon}
              style={{ color: tagsInfo[key].color }}
              data-for={tooltipId}
              data-tip={tagsInfo[key].text}
            />
          );
        }
        return null;
      })}

      <ReactTooltip id={tooltipId} getContent={(dataTip) => dataTip} />
    </>
  );
};
